'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function makeIsSameOption(_ref) {
  var reference = _ref.reference;

  if (reference) return function (a, b) {
    return a._id === b._id;
  };
  return function (a, b) {
    return a === b;
  };
}

function toArray(value) {
  if (Array.isArray(value)) return value;

  if (value === null || value === undefined) return [];
  return [value];
}
function complementOptions(_ref2) {
  var value = _ref2.value,
      options = _ref2.options,
      isSameOption = _ref2.isSameOption;

  var values = toArray(value);

  return values.reduce(function (opts, val) {
    if (opts.find(function (opt) {
      return isSameOption(opt, val);
    })) return opts;
    return [val].concat(_toConsumableArray(opts));
  }, options);
}

var array = _propTypes2.default.array,
    any = _propTypes2.default.any,
    string = _propTypes2.default.string;

var enhancer = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  reference: string,
  options: array.isRequired,
  value: any
}), (0, _withPropsOnChange2.default)(['reference'], function (props) {
  return {
    isSameOption: makeIsSameOption(props)
  };
}), (0, _exposeProps2.default)(function (props) {
  return {
    options: complementOptions(props)
  };
}));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'complementOptions');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/processOptions/complementOptions.js
// module id = 1642
// module chunks = 0